import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "helpTip",
  "use": "helpTip-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"helpTip\"><path d=\"M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm3.6 9.6c-.5.5-1 .8-1.6 1.1-.6.3-1.3.4-2 .4s-1.4-.1-2-.4c-.6-.3-1.2-.6-1.6-1.1-.5-.5-.8-1-1.1-1.6C1 7.4.9 6.7.9 6s.1-1.4.4-2c.3-.6.6-1.2 1.1-1.6.5-.5 1-.8 1.6-1.1.6-.3 1.3-.4 2-.4s1.4.1 2 .4c.6.3 1.2.6 1.6 1.1.5.5.8 1 1.1 1.6.3.6.4 1.3.4 2s-.1 1.4-.4 2c-.2.6-.6 1.2-1.1 1.6zM5.9 7.8c-.3 0-.4-.2-.4-.5.1-.6.5-1.1 1-1.5.8-.8.8-1 .8-1.3 0-.3-.1-.6-.3-.8-.2-.3-.6-.4-1-.4-.7 0-1.3.6-1.3 1.3 0 .2-.2.4-.4.4s-.4-.2-.4-.4c0-.6.2-1.1.6-1.5.4-.4.9-.6 1.5-.6s1.2.2 1.6.7c.4.4.6.9.5 1.4 0 .5-.2 1-1 1.8-.4.4-.7.7-.7 1-.1.2-.2.4-.5.4zM5.4 9c0 .2.1.3.3.4s.4.1.5 0 .3-.3.3-.4c0-.3-.2-.5-.5-.5s-.6.2-.6.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/helpTip.svg
// module id = XJgd
// module chunks = 6